/**
 * PrimeIcons per production menu name (new UI). Shared by the sidebar and the
 * dashboard quick links so a shortcut shows the same icon as its menu entry.
 * Unknown names return '' so callers can fall back to the menu's own image icon.
 */
export const MENU_ICONS: Readonly<Record<string, string>> = {
  Dashboard: 'pi-th-large',
  Competitions: 'pi-trophy',
  'Federation Leagues': 'pi-flag',
  Sessions: 'pi-calendar',
  'Holiday Camps': 'pi-sun',
  Events: 'pi-ticket',
  'School Sessions': 'pi-book',
  Bookings: 'pi-calendar-plus',
  'Food & Beverage': 'pi-shop',
  Members: 'pi-users',
  Membership: 'pi-id-card',
  'Staff Management': 'pi-briefcase',
  Email: 'pi-envelope',
  Polls: 'pi-chart-pie',
  Notification: 'pi-bell',
  Shop: 'pi-shopping-cart',
  Reports: 'pi-chart-bar',
  Payments: 'pi-credit-card',
  Wallet: 'pi-wallet',
  Setup: 'pi-cog',
  'Help & Feedback': 'pi-comments',
  'Manage Orders': 'pi-list',
  Inventory: 'pi-box',
  Member: 'pi-users',
  'Facility Booking': 'pi-calendar-plus',
};

export function menuIcon(name: string | null | undefined): string {
  return (name && MENU_ICONS[name]) || '';
}
